/* eslint-disable no-undef */
import dateFormat from "dateformat";
import ElectronicServices from "./ElectronicServices";
import { Helpers } from "common-functions";

var port = 8080;
var scanToken;
var printToken;

export const swipeRequest = (
    successCallback,
    errorCallback,
    entryMethods,
    timeout = 20,
) => {
    var oRequest = null;

    oRequest = new ElectronicServices.CaptureSwipeRequest(
        JSON.stringify({
            AllowedEntryMethods: entryMethods,
            PromptTimeoutSeconds: timeout,
        }),
    );

    oRequest.OnTokenReceived = function (strToken) {
        scanToken = strToken;
    };

    oRequest.OnSwipeDataReady = function (
        strEntryMethod,
        strRawData,
        bError,
        bTimeout,
    ) {
        if (bError) {
            errorCallback("Error on swipe");
        } else if (bTimeout) {
            errorCallback("Timeout error");
        } else if (strRawData !== "" || strRawData === "") {
            successCallback(strRawData);
        }
        scanToken = "";
    };

    ElectronicServices.iPortNumber = port;
    oRequest.NeedTheExtendedBarcode = true;
    ElectronicServices.RequestSwipe(oRequest);
};

export const cancelSwipe = (onResponse) => {
    if (scanToken !== "" && scanToken !== undefined) {
        ElectronicServices.iPortNumber = port;
        ElectronicServices.CancelSwipe(scanToken, onResponse);
        scanToken = "";
    } else if (onResponse) {
        onResponse("Cancel swipe: SUCCESS");
    }
};

export const customerDisplayCD = (displayText) => {
    var oRequest = {
        CustomerText: displayText,
        PromptTimeoutSeconds: 10,
        MessageTarget: ["CustomerDisplay"],
    };

    ElectronicServices.iPortNumber = port;
    ElectronicServices.CustomerDisplayMessage(JSON.stringify(oRequest));
};

export const printCancelledTransaction = (
    cancelTransactionProps,
    successCallback,
    errorCallback,
) => {
    const {
        createdDate,
        productName,
        operatorInstructionsReceipt,
        saleValue,
        eServiceTransactionNumber,
        formattedCreatedDate,
    } = cancelTransactionProps;
    const dateObject = new Date(createdDate);
    const convertedDate = dateFormat(
        dateObject.toString(),
        "ddd mmm d yyyy HH:MM:ss",
    );
    const printTexts = [
        "Cancellation of Uncommitted e-Service",
        "Product has been submitted successfully.",
        "&newLine",
        `e-Service Transaction Number: ${eServiceTransactionNumber}`,
        `Date: ${formattedCreatedDate}`,
        `Product: ${productName}`,
        "Total Sale Value (including all product",
        `sub-items): $${Helpers.formatMoney(saleValue)}`,
        "&newLine",
    ];

    var oRequest = new ElectronicServices.PrintReceiptRequest();
    printTexts.forEach((printText, index) => {
        let command1 = {};
        if (printText === "&newLine") {
            command1 = new ElectronicServices.ReceiptNewLine();
        } else {
            command1 = new ElectronicServices.ReceiptTextLine(printText);
            if (index <= 1) {
                command1.Bold = "Yes";
            }
        }
        oRequest.AddCommand(command1);
    });

    const command2 = new ElectronicServices.ReceiptTextLine("Instructions:");
    command2.Bold = "Yes";
    oRequest.AddCommand(command2);

    operatorInstructionsReceipt.forEach((instruction) => {
        oRequest.AddCommand(
            new ElectronicServices.ReceiptTextLine(instruction),
        );
    });

    oRequest.AddCommand(new ElectronicServices.ReceiptCutPaper(false));

    var OnTokenReceived = function (strToken, bError, bTimeout) {
        if (bError || bTimeout) {
            if (errorCallback) {
                errorCallback("Error: " + bError);
            }
        } else if (successCallback) {
            successCallback();
        }
    };

    ElectronicServices.iPortNumber = port;
    ElectronicServices.PrintReceipt(JSON.stringify(oRequest), OnTokenReceived);
};

export const printReceipt = () => {
    // eslint-disable-next-line no-undef
    CreateSpinner(spinner_div, "black");
    var oImage = new ElectronicServices.ReceiptImage(
        "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",
    );

    var textLine1 = new ElectronicServices.ReceiptTextLine(
        "07/05/2012(Thu) 16:46:17",
    );
    textLine1.Align = "Center";
    textLine1.Font = "Small";

    var textLine2 = new ElectronicServices.ReceiptTextLine("Optus Voucher");
    textLine2.Align = "Center";

    textLine2.Bond = "Yes";

    var oBarcode = new ElectronicServices.ReceiptBarcode("12334345");

    var textLine3 = new ElectronicServices.ReceiptTextLine(
        "Acknowledgement Receipt",
    );
    textLine3.Align = "Center";

    var textLine4 = new ElectronicServices.ReceiptTextLine("**Customer Copy**");
    textLine4.Align = "Center";

    var cutPaper = new ElectronicServices.ReceiptCutPaper(false);

    var oRequest = new ElectronicServices.PrintReceiptRequest();
    oRequest.AddCommand(oImage);
    oRequest.AddCommand(textLine1);
    oRequest.AddCommand(oBarcode);
    oRequest.AddCommand(textLine2);
    oRequest.AddCommand(textLine3);
    oRequest.AddCommand(textLine4);
    oRequest.AddCommand(cutPaper);

    var OnToken = function (strToken, bError, bTimeout) {
        if (bError || bTimeout) {
            // alert("OnToken - Error: " + bError + " Timeout: " + bTimeout);
            $("div.failure").text(
                "OnToken - Error: " + bError + " Timeout: " + bTimeout,
            );
            $("div.failure").fadeIn(300).delay(1500).fadeOut(400);
        } else {
            printToken = strToken;
            $("div.success").text("Print Success with token " + strToken);
            $("div.success").fadeIn(300).delay(1500).fadeOut(400);
        }
    };

    ElectronicServices.iPortNumber = port;
    ElectronicServices.PrintReceipt(JSON.stringify(oRequest), OnToken);
    //document.myform.PrintMessage.value = "Printing the sample voucher --" + "        " + JSON.stringify(oRequest);
    // DisableSpinner();
};
